// extracted by mini-css-extract-plugin
module.exports = {"fourOFour":"FourOFourContents-module--four-o-four--3hbog","fourOFour__title":"FourOFourContents-module--four-o-four__title--3QlBS"};